import { persistentAtom } from '@nanostores/persistent'

export const nostoSessionParams = persistentAtom(
    'nosto_session_params',
    null,
    {
        encode(sessionParams) {
            return JSON.stringify(sessionParams)
        },
        decode(sessionParams) {
            try {
                return JSON.parse(sessionParams)
            } catch (error) {
                console.error('Error decoding Nosto session params:', error)
                return null
            }
        },
    }
)

// Helper function to detect if we're in a preview environment
export const isPreviewEnvironment = () => {
    if (typeof window === 'undefined') return false
    return window.location.hostname.includes('vercel.app') ||
           window.location.hostname.includes('preview') ||
           window.location.hostname.includes('staging')
}

// Helper function to get session params from Nosto API
export const getNostoSessionParams = async () => {
    try {
        // Check if we're in a preview environment
        if (isPreviewEnvironment()) {
            return null;
        }

        if (typeof window !== 'undefined' && window.nostojs) {
            return new Promise((resolve) => {
                // Add a timeout to prevent hanging
                const timeout = setTimeout(() => {
                    resolve(null);
                }, 3000); // 3 second timeout

                try {
                    window.nostojs((api) => {
                        // Check if the API has the required method
                        if (typeof api.getSearchSessionParams === 'function') {
                            api.getSearchSessionParams()
                                .then(response => {
                                    clearTimeout(timeout);
                                    console.log('Nosto session params retrieved:', response);
                                    resolve(response);
                                })
                                .catch(error => {
                                    clearTimeout(timeout);
                                    console.error('Error getting Nosto session params:', error);
                                    resolve(null);
                                });
                        } else if (typeof api.getSessionParams === 'function') {
                            // Try alternative method name
                            api.getSessionParams()
                                .then(response => {
                                    clearTimeout(timeout);
                                    console.log('Nosto session params retrieved (alt method):', response);
                                    resolve(response);
                                })
                                .catch(error => {
                                    clearTimeout(timeout);
                                    console.error('Error getting Nosto session params (alt method):', error);
                                    resolve(null);
                                });
                        } else {
                            // If no session params method is available, try to get from default session
                            clearTimeout(timeout);
                            try {
                                api.defaultSession()
                                    .then(session => {
                                        if (session && session.params) {
                                            resolve(session.params);
                                        } else {
                                            resolve(null);
                                        }
                                    })
                                    .catch(error => {
                                        console.error('🔍 getNostoSessionParams - Error getting default session:', error);
                                        resolve(null);
                                    });
                            } catch (error) {
                                console.error('🔍 getNostoSessionParams - Error accessing default session:', error);
                                resolve(null);
                            }
                        }
                    });
                } catch (error) {
                    clearTimeout(timeout);
                    console.error('🔍 getNostoSessionParams - Error calling nostojs:', error);
                    resolve(null);
                }
            });
        }
        return null;
    } catch (error) {
        console.error('Error in getNostoSessionParams:', error);
        return null;
    }
}

// Helper function to initialize session params on page load
export const initializeNostoSessionParams = async () => {
    try {
        const sessionParams = await getNostoSessionParams()
        if (sessionParams) {
            nostoSessionParams.set(sessionParams)
            console.log('Nosto session params initialized and stored')
        }
    } catch (error) {
        console.error('Error initializing Nosto session params:', error)
    }
}
